import { render } from "./ManageLesson.vue?vue&type=template&id=ed265f86&scoped=true"
import script from "./ManageLesson.vue?vue&type=script&lang=js"
export * from "./ManageLesson.vue?vue&type=script&lang=js"

import "./ManageLesson.vue?vue&type=style&index=0&id=ed265f86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed265f86"]])

export default __exports__